import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-loading-button',
  templateUrl: './loading-button.component.html',
  styleUrls: ['./loading-button.component.scss'],
})
export class LoadingButtonComponent {
  @Input() showLoading: boolean = false;
  @Input() diameter = 24;
  @Input() disabled = false;
  @Input() class = '';
  @Input() loadingText = '';
  @Input() submit = false;
}
